<button
  #buttonElement
  class="button-arrow {{'button-arrow--' + direction}} {{size ? 'button-arrow--' + size : undefined}} {{classNames}}"
  [attr.aria-label]="ariaLabel"
  (click)="clickEmitter.emit()"
>
  <app-ui-icon *ngIf="direction === 'left'" [name]="'icon-arrow-left-small'" [width]="10" [height]="14"></app-ui-icon>
  <app-ui-icon *ngIf="direction === 'right'" [name]="'icon-arrow-right-small'" [width]="10" [height]="14"></app-ui-icon>
</button>
